import { createRef, h } from "preact";
import { useEffect, useLayoutEffect, useState } from "preact/hooks";

import CurrencyField from "../CurrencyField.jsx";
import { getTextOfAnswer } from "./helper.js";

export default function Money(props) {
  const [value, setValue] = useState((props.answer && props.answer[0]) || "");
  const [currency, setCurrency] = useState(
    (props.answer && props.answer[1]) || ""
  );
  const ref = createRef();

  function handleValueChange(v) {
    setValue(v);
    props.onSelect({
      number: v,
      currency: currency,
    });
  }

  function handleCurrencyChange(v) {
    setCurrency(v);
    props.onSelect({
      number: value,
      currency: v,
    });
  }

  useEffect(() => {
    setValue(getTextOfAnswer(props.answer));
    setCurrency(props.options.currency || "EUR");
  }, []);
  useLayoutEffect(() => {
    M.AutoInit(ref.current);
  }, []);

  return (
    <div class="mb-32" ref={ref}>
      <CurrencyField
        id="question-suggested"
        name="answer"
        min="0"
        value={value}
        info={props.options.helperText}
        error={props.error}
        currency={currency}
        currencyOptions={[currency, "EUR", "USD"]}
        onChange={(value) => handleValueChange(value)}
        onCurrencyChange={(value) => handleCurrencyChange(value)}
      />
    </div>
  );
}
